import { render, staticRenderFns } from "./SaleOrderTable.vue?vue&type=template&id=4c20a4ed&"
import script from "./SaleOrderTable.vue?vue&type=script&lang=js&"
export * from "./SaleOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./SaleOrderTable.vue?vue&type=style&index=0&id=4c20a4ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports